/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=0dd23d15"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0dd23d15&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_9SbA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__